import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { ResultType } from 'Types/common';

export const isMaiorAAResultAndIsToPay = (
  data: ResultType,
  previousYearInfo?: PueblaPreviousYearsResponse
): boolean => {
  if (!previousYearInfo) return false;

  return (
    Math.abs(previousYearInfo.amountPending) > Math.abs(data?.taxReturnResult ?? 0) &&
    data?.taxReturnType === TaxReturnTypes.TO_PAY &&
    data?.mandatory
  );
};

export const isMaiorDaResultOrEqual = (
  data: ResultType,
  previousYearInfo?: PueblaPreviousYearsResponse
): boolean => {
  if (!previousYearInfo) return false;

  return (
    (Math.abs(previousYearInfo.amountPending) === Math.abs(data?.taxReturnResult ?? 0) ||
      Math.abs(data?.taxReturnResult ?? 0) > Math.abs(previousYearInfo.amountPending)) &&
    data?.taxReturnType === TaxReturnTypes.TO_PAY &&
    data?.mandatory
  );
};
